export const GAME_TRANSFER_FORMAT = 'bar-bluff-game'
export const GAME_TRANSFER_VERSION = 1

export type TransferQuestionType = 'OPEN_TEXT' | 'MULTIPLE_CHOICE_TEXT' | 'MULTIPLE_CHOICE_IMAGE' | 'NUMERIC_MEDIAN' | 'NUMERIC_MODE'

export interface TransferChoice {
  id: string
  label?: string
  imageUrl?: string
}

/** A remembered or seeded answer. For choice questions `answer` is the choice id. */
export interface TransferStandardAnswer {
  answer: string
  count: number
}

export interface TransferQuestion {
  type: TransferQuestionType
  prompt: string
  points: number
  scoring: Record<string, number>
  choices: TransferChoice[] | null
  timeLimitSeconds: number | null
  hostNotes: string | null
  imageUrl: string | null
  active: boolean
  standardAnswers: TransferStandardAnswer[]
}

export interface TransferRound {
  name: string
  questions: TransferQuestion[]
}

export interface TransferGameSettings {
  profanityFilterEnabled: boolean
  allowNegativeTotalScore: boolean
  answerAveragingEnabled: boolean
  maxTeamSize: number | null
}

export interface TransferGame {
  name: string
  description: string | null
  themeId: string
  settings: TransferGameSettings
  rounds: TransferRound[]
}

/** The portable file format for a game, or for a subset of its rounds. Ids and ordering columns are never included. */
export interface GameTransferDocument {
  format: typeof GAME_TRANSFER_FORMAT
  formatVersion: typeof GAME_TRANSFER_VERSION
  exportedAt: string
  appVersion: string
  game: TransferGame
}

export interface GameImportResult {
  id: string
  roundsImported: number
  questionsImported: number
  warnings: string[]
}
